import React, { useState, Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import { withRouter } from "react-router";

import apiResponse from "../../../../services/apiResponse";

import DetailBloc from "./Blocs/DetailBloc";
import moment from "moment";

class IndexView extends Component {
  detailBloc = new DetailBloc();

  constructor(props) {
    super(props);
    this.state = {};
  }

  rupiah = (num) => {
    let res = "-";
    if (num != null && num != "") {
      res = parseFloat(num).toLocaleString("id-ID", {
        maximumFractionDigits: 2,
      });
    }
    return res;
  };

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid") });
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Detail Gaji Pokok</CardTitle>
                  {/* <CardSubtitle className="mb-3">
                                        Informasi Detail Gaji Pokok
                                    </CardSubtitle> */}
                  <hr />
                  <Row className="mb-3">
                    <label className="col-md-3">Nama Pangkat</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.rank_name !== ""
                            ? this.state.detail.rank_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Golongan/Ruang</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.rank_group_room !== ""
                            ? this.state.detail.rank_group_room
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Masa Kerja</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.salary_years_of_work !== ""
                            ? this.state.detail.salary_years_of_work
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "10%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Gaji Pokok</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.salary_value !== ""
                            ? `Rp ${this.rupiah(
                                this.state.detail.salary_value
                              )}`
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "20%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Tahun</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.salary_year_active !== ""
                            ? this.state.detail.salary_year_active
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "10%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">PP</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.salary_pp_name !== ""
                            ? this.state.detail.salary_pp_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "40%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="3"></Col>
                    <Col md="9">
                      <Link to="?" className="waves-effect">
                        <Button color="danger">
                          <i className="uil-arrow-left"></i> Kembali
                        </Button>
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
